import { watch } from 'vue'

import { useKidStore } from '@stores/kid'

import { useUpsellBannerApi } from '@api/upsell-banner/upsell-banner.hook'

export const useUpsellBannerLoad = (): void => {
  const kidStore = useKidStore()
  const { fetchUpsellBanner } = useUpsellBannerApi()

  watch(() => kidStore.activeKidId, (kidId) => {
    if (typeof kidId !== 'number') return

    void fetchUpsellBanner()
  }, { immediate: true })
}
